const UPDATE_REF_CODE = 'UPDATE_REF_CODE';

const initialState = {
  refCode: '',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_REF_CODE: {
      return { refCode: action.payload.refCode };
    }
    default:
      return state;
  }
};

export const updateRefCode = payload => ({
  type: UPDATE_REF_CODE,
  payload,
});

export default reducer;
